<template>
    <div>
        <v-btn
            @click="toggleAddDialog()"
            class="info text--white"
            slot="activator"
        >Add Employment
        </v-btn>
        <v-dialog
            :value="addPersonEmploymentDialog"
            max-width="500px"
            persistent
            v-if="!hasOpenEmployment"
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Employment</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleAddDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :error-messages="addEcsCompanyIdErrors"
                                    :items="ecsCompanyList"
                                    @blur="$v.addEcsCompanyId.$touch()"
                                    @input="$v.addEcsCompanyId.$touch()"
                                    item-text="name"
                                    item-value="ecsCompanyId"
                                    label="ECS Company"
                                    v-model="addEcsCompanyId"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-autocomplete
                                    :error-messages="addJobIdErrors"
                                    :items="liveJobList"
                                    @blur="$v.addJobId.$touch()"
                                    @input="$v.addJobId.$touch()"
                                    item-text="name"
                                    item-value="jobId"
                                    label="Job"
                                    v-model="addJobId"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :error-messages="addEmploymentTypeIdErrors"
                                    :items="employmentTypeList"
                                    @blur="$v.addEmploymentTypeId.$touch()"
                                    @input="$v.addEmploymentTypeId.$touch()"
                                    item-text="name"

                                    item-value="employmentTypeId"
                                    label="Employment Type"
                                    v-model="addEmploymentTypeId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addWeeklyHoursErrors"
                                    @blur="$v.addWeeklyHours.$touch()"
                                    @input="$v.addWeeklyHours.$touch()"
                                    label="Weekly Hours"
                                    max="168"
                                    min="0"

                                    step="0.25"
                                    type="number"
                                    v-model="addWeeklyHours"
                                />
                            </v-flex>
                            <v-menu
                                xs12
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"

                                v-model="startDateMenu"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :error-messages="addStartDateErrors"
                                        @blur="$v.addStartDate.$touch()"
                                        @input="menu2 = false && $v.addStartDate.$touch()"
                                        clearable
                                        label="Start Date"
                                        prepend-icon="event"
                                        readonly
                                        slot="activator"
                                        v-model="addStartDate"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    :error-messages="addStartDateErrors"
                                    :max="addEndDate"
                                    @blur="$v.addStartDate.$touch()"
                                    @input="startDateMenu = false && $v.addStartDate.$touch()"
                                    no-title
                                    scrollable
                                    v-model="addStartDate"
                                />
                            </v-menu>


                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"

                                v-model="endDateMenu"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :error-messages="addEndDateErrors"
                                        @blur="$v.addEndDate.$touch()"
                                        @input="menu2 = false && $v.addEndDate.$touch()"
                                        label="End Date"
                                        prepend-icon="event"
                                        readonly
                                        slot="activator"
                                        v-model="addEndDate"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    :error-messages="addEndDateErrors"
                                    :min="addStartDate"
                                    @blur="$v.addEndDate.$touch()"
                                    @input="endDateMenu = false && $v.addEndDate.$touch()"

                                    no-title
                                    scrollable
                                    v-model="addEndDate"
                                >
                                <v-btn text color="primary" @click="() => {this.addEndDate = null}">Clear</v-btn>
                                </v-date-picker>
                            </v-menu>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                                    @blur="$v.addIsAllowedToil.$touch()"
                                    @input="$v.addIsAllowedToil.$touch()"
                                    item-text="name"

                                    item-value="Id"
                                    label="Allowed TOIL"
                                    v-model="addIsAllowedToil"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                                    @blur="$v.addIsAllowedExpenses.$touch()"
                                    @input="$v.addIsAllowedExpenses.$touch()"
                                    item-text="name"

                                    item-value="Id"
                                    label="Allowed Expenses"
                                    v-model="addIsAllowedExpenses"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    data-vv-name="comments"
                                    label="Comments"
                                    v-model="addComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveNewItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            :value="addPersonEmploymentDialog"
            max-width="500px"
            persistent
            v-else
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Employment</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleAddDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="subtitle-1">
                    Add end date to existing employments before adding another
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { FETCH_PERSON_EMPLOYMENT_LIST, SAVE_NEW_PERSON_EMPLOYMENT } from "@/store/person_employment/actions.js";
import { RESET_DEFAULT_NEW_PERSON_EMPLOYMENT, TOGGLE_NEW_PERSON_EMPLOYMENT_DIALOG, UPDATE_ADD_PERSON_EMPLOYMENT_FIELD } from "@/store/person_employment/mutations.js";
import { helpers, required, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';

    export default {
        name: "AddPersonEmploymentDialog",

        validations: {
            addEcsCompanyId: {required},
            addJobId: {required},
            addEmploymentTypeId: {required},
            addWeeklyHours: {required},
            addStartDate: {required, minValue: value => moment(value, 'YYYY-MM-DD', true).isValid()},
            addEndDate: {minValue: (value) => !helpers.req(value) || moment(value, 'YYYY-MM-DD', true).isValid()},
        },


        mixins: [
            EditTableFunctions,
        ],


        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: () => ({
            startDateMenu: false,
            endDateMenu: false,
        }),


        computed: {
            ...mapGetters(
            [

                "employmentTypeList",
                "liveJobList",
                "ecsCompanyList",
                "hasOpenEmployment",
            ],
            ),

            ...mapGetters(
            ["addPersonEmploymentDialog",
            ]
            ),
            addEcsCompanyId: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.ecsCompanyId;
                },
                set(value) {
                    this.updateNewValue('ecsCompanyId', value);
                },
            },
            addEcsCompanyIdErrors() {
                const errors = [];
                if (!this.$v.addEcsCompanyId.$dirty) return errors;
                !this.$v.addEcsCompanyId.required && errors.push('required.');
                return errors
            },
            addJobId: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.jobId;
                },
                set(value) {
                    this.updateNewValue('jobId', value);
                },
            },
            addJobIdErrors() {
                const errors = [];
                if (!this.$v.addJobId.$dirty) return errors;
                !this.$v.addJobId.required && errors.push('required.');
                return errors
            },
            addEmploymentTypeId: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.employmentTypeId;
                },
                set(value) {
                    this.updateNewValue('employmentTypeId', value);
                },
            },
            addEmploymentTypeIdErrors() {
                const errors = [];
                if (!this.$v.addEmploymentTypeId.$dirty) return errors;
                !this.$v.addEmploymentTypeId.required && errors.push('required.');
                return errors
            },
            addWeeklyHours: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.weeklyHours;
                },
                set(value) {
                    this.updateNewValue('weeklyHours', value);
                },
            },
            addWeeklyHoursErrors() {
                const errors = [];
                if (!this.$v.addWeeklyHours.$dirty) return errors;
                !this.$v.addWeeklyHours.required && errors.push('required.');
                return errors
            },
            addStartDate: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.startDate;
                },
                set(value) {
                    this.updateNewValue('startDate', value);
                },
            },
            addStartDateErrors() {
                const errors = [];
                if (!this.$v.addStartDate.$dirty) return errors;
                !this.$v.addStartDate.required && errors.push('required.');
                !this.$v.addStartDate.minValue && errors.push('Must be valid date.');
                return errors
            },
            addEndDate: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.endDate;
                },
                set(value) {
                    this.updateNewValue('endDate', value);
                },
            },
            addEndDateErrors() {
                const errors = [];
                if (!this.$v.addEndDate.$dirty) return errors;
                !this.$v.addEndDate.minValue && errors.push('Must be valid date.');
                return errors
            },
            addComments: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.comments;
                },
                set(value) {
                    this.updateNewValue('comments', value);
                },
            },
            addIsAllowedToil: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.isAllowedToil;
                },
                set(value) {
                    this.updateNewValue('isAllowedToil', value);
                },
            },
            addIsAllowedExpenses: {
                get() {
                    return this.$store.state.person_employment.addPersonEmployment.isAllowedExpenses;
                },
                set(value) {
                    this.updateNewValue('isAllowedExpenses', value);
                },
            },
        },

        mounted() {
            if (this.personId !== undefined) {
                this.resetNewItemToDefault();
                this.updateNewValue('personId', this.personId);
            }
        },

        methods: {
            // async validateAll() {
            //
            //     this.$v.$touch();
            //
            //     let formState = false;
            //
            //     if (this.$v.$anyDirty === false) {
            //         formState = 'clean';
            //     } else {
            //         if (this.$v.$anyError === true) {
            //             formState = 'error';
            //         } else {
            //             formState = 'complete';
            //         }
            //     }
            //
            //     let areValid = false;
            //
            //     if (formState == 'complete') {
            //         areValid = true;
            //     }
            //
            //     return areValid;
            // },
            ...mapActions({
                fetchTableList: FETCH_PERSON_EMPLOYMENT_LIST,
                saveNewTableItemRecord: SAVE_NEW_PERSON_EMPLOYMENT,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_PERSON_EMPLOYMENT_DIALOG,
                // loadTableItemToEdit: LOAD_PERSON_SUMMARY_TO_EDIT,
                updateTableItemToAdd: UPDATE_ADD_PERSON_EMPLOYMENT_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_PERSON_EMPLOYMENT,
            }),
        }
    }
</script>

<style scoped>

</style>
